import rest from "../script/rest";

class ResourceRest {

    async getAppVersion() {
        const url = "/rest/resource/getAppVersion";
        const response = await rest.get(url);
        const json = await response.json();
        return json.value;
    }

    async getBundleChecksum() {
        const url = "/rest/resource/getBundleChecksum";
        const options = {
            method: "get",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json" }
        };
        const response = await fetch(encodeURI(url), options);
        const json = await response.json();
        return json.value;
    }

    async getDocumentChecksums() {
        const url = "/rest/resource/getDocumentChecksums";
        const response = await rest.get(url);
        const json = await response.json();
        return json;
    }

    async uploadDocument(name, file, documentType) {
        const url = "/rest/resource/document/uploadDocument";
        await rest.file(url, name, file, documentType);
    }
}
const resourceRest = new ResourceRest();
window.resourceRest = resourceRest;
export default resourceRest;